import { Station } from 'src/app/models/station';
import { ArService } from './../../services/ar.service';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { NotifierService } from 'angular-notifier';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';
import { ValidateCCardNumber, ValidateIsExpiry, validateAllZeros, validateAllCCZeros } from 'src/app/shared/ccard.validator';
import {StoreService} from "../../../stores/setting.store";


@Component({
  selector: 'app-add-customer-service',
  templateUrl: './add-customer-service.component.html',
  styleUrls: ['./add-customer-service.component.scss']
})
export class AddCustomerServiceComponent implements OnInit {



  minDate = new Date();
  today = moment().format('MM/DD/YYYY');
  customerTypes = ['AMEX', 'Retail'];
  statusTypes = [{
    id: false,
    name: "InActive",
    active: 0
  },
  {
    id: true,
    name: "Active",
    active: 1
  }
  ]

  allTransactionTypes = [{
    name: "Credit Card"
  },
  {
    name: "Cheque"
  }
  ]

  ccConfirmation = [{
    name: "Yes"
  },
  {
    name: "No"
  }
  ]




  customerForm: FormGroup;
  isEditMode = false;
  formTitle = '';
  submitted = false
  customerData: any;
  selectedStations: any;
  allStations: any;
  selectedCustomerType: any;
  customerByStationId;
  customerServicesId;
  isAmountChanged = false;
  allAgencies: any;
  filterAgencies: any

  PHONE_REGEXP = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4,5}$/;
  agenciesByStations = [];
  capitalOneVisibleOffer: boolean = false;
  capitalOneDiscount: number = 0;
  capitalOneBinNumbers: number[] = [];

  public maskDate: Array<string | RegExp>;
  public maskCreditCard: Array<string | RegExp>;
  public constructor(
    private notifier: NotifierService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private authService: AuthenticationService,
    private router: Router,
    private storeService: StoreService,
    public arService: ArService) {
    this.maskDate = [/\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
    this.maskCreditCard = [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/];
  }


  ngOnInit() {
    //this.onCardConfirmationChange();
    this.storeService.getSettingByKey('core::capitalOneVisibleOffer').subscribe(data => {
      try {
        this.capitalOneVisibleOffer = data ? JSON.parse(data) : false;
      } catch (e) {
        console.error('Error parsing capitalOneVisibleOffer:', e);
        this.capitalOneVisibleOffer = false;
      }
    });

    this.storeService.getSettingByKey('core::capitalOneDiscount').subscribe(data => {
      try {
        this.capitalOneDiscount = data ? JSON.parse(data) : 0;
      } catch (e) {
        console.error('Error parsing capitalOneDiscount:', e);
        this.capitalOneDiscount = 0;
      }
    });

    this.storeService.getSettingByKey('core::capitalOneBinNumbers').subscribe(data => {
      try {
        this.capitalOneBinNumbers = data ? JSON.parse(data) : [];
      } catch (e) {
        console.error('Error parsing capitalOneBinNumbers:', e);
        this.capitalOneBinNumbers = [];
      }
    });
    this.getStations();
    this.getAllAgencyNamesByStationId();
    if (this.route.snapshot.paramMap.get('customerId') != null) {
     // console.log(this.route.snapshot.paramMap.get('customerId'), 'This is Customer Id from URL')
      this.formTitle = "Update Customer";
      this.isEditMode = true;
      this.getCustomerById(this.route.snapshot.paramMap.get('customerId'));
    } else {
      this.formTitle = "Add Customer"
    }
    this.initAddCustomerForm();
  }

  getCustomerById(customerId) {
   // console.log(customerId, "Customer ID from Get customers")
    this.selectedStations;
    this.spinner.show();
    this.arService.getCustomerDataById(customerId).subscribe(async cData => {
      this.customerData = cData['result']
     // console.log(this.customerData)
      this.selectedStations = this.customerData[0].STATION;
      //console.log(this.selectedStations)
      let data = {
        station: this.customerData[0].STATION
      }
      this.arService.getAllAgenciesByStationId(data).subscribe((agenciesData) => {
        this.agenciesByStations = agenciesData['result']
         //console.log(this.allAgencies)
      })
      this.spinner.hide();
      this.initUpdateCustomerForm();
    });
  }

  getStations() {
    this.arService.getAllstationsWithCode().subscribe((stationData) => {
      this.allStations = stationData['result']
    })
  }

  getAllAgencyNamesByStationId() {
    this.arService.getAllAgenciesData().subscribe((agenciesData) => {
      this.allAgencies = agenciesData['result']
       //console.log(this.allAgencies)
    })
  }

  getAgenciesByStation(station) {
    let data = {
      station: station
    }
    this.arService.getAllAgenciesByStationId(data).subscribe((agenciesData) => {
      this.agenciesByStations = agenciesData['result']
       //console.log(this.agenciesByStations)
    })
  }

  onStationChange(event) {
    this.selectedStations = (event)
   // console.log('station: ' + this.selectedStations)
    this.agenciesByStations = this.allAgencies.filter((obj) => {
      return obj.STATION == this.selectedStations
    })
  }

  onAddCustomer(values) {
    this.submitted = true;
    this.validateCustomer();
    this.customerForm.markAllAsTouched();
    if (this.customerForm.invalid) {
      return;
    }


    let ccNumber,expWithYear,ccExp;
    
    if(values.ccConfirmation== 'Yes'){
      ccNumber = values.creditCardNo.replace(/\s/g, '');
      ccExp = values.expireMonthYear.split("/");
      expWithYear = ccExp[1] + ccExp[0];
    }
    const isCapitalOne = this.isCapitalOneValidate() ? 'Capital One' : null;
    var data = {
      STATION: values.station,
      AGENCY_ID: values.agency_Name,
      COMPANY_NAME: values.company_Name,
      COUNTRY : values.country,
      CONTACT_NAME: values.contact_Name,
      CONTACT_EMAIL: values.contact_Email,
      CONTACT_PHONE: values.contact_Phone,
      CONTACT_FAX: values.contact_Fax,
      CUSTOMER_DESCRIPTION: values.customer_Description,
      ADDRESS1: values.address_1,
      ADDRESS2: values.address_2,
      STATE: values.state,
      CITY: values.city,
      ZIPCODE: values.zipcode,
      NET_TERMS: values.net_Terms,
      PROF_CUST_REFNUM: values.prof_Cust_RefNum == '' ? null : values.prof_Cust_RefNum,
      TRANSACTION_TYPE: values.transaction_Type,
      LCB_ID: this.authService.getCurrentUserId(),
      ACTIVE: true,
      creditCardNo: ccNumber,
      ccConfirmation: values.ccConfirmation,
      expireMonthYear: expWithYear,
      promotionalContract: values.transaction_Type === 'Credit Card' ? isCapitalOne : false
    }

    this.spinner.show()
    this.arService.addCustomersData(data).subscribe(res => {
      if (res['status']) {
        this.spinner.hide();
        this.submitted = false;
        this.notifier.notify('success', res['message']);
      //  this.initAddCustomerForm();
        this.router.navigateByUrl("home/customers");
      } else {
        this.submitted = false;
        this.spinner.hide();
        this.notifier.notify('danger', res['message'])
      }
    }, err => {
      this.notifier.notify('danger', err.message)
      console.log(err);
    })  
    this.router.navigateByUrl("home/customers");  
  }

  initAddCustomerForm() {
    // let st = moment().format('MM/DD/YYYY');
    this.customerForm = this.formBuilder.group({
      station: new FormControl('', Validators.compose([Validators.required])),
      agency_Name: new FormControl(''),
      company_Name: new FormControl('', Validators.compose([Validators.required])),
      country : new FormControl('',Validators.compose([Validators.required, Validators.maxLength(2), Validators.pattern('[A-Za-z]{0,2}')])),
      contact_Name: new FormControl('', Validators.compose([Validators.required])),
      contact_Email: new FormControl('', Validators.compose([Validators.required, Validators.email])),
      contact_Phone: new FormControl('', Validators.compose([Validators.pattern('[0-9\-\+]*')])),  // Validators.minLength(10), Validators.maxLength(20), Validators.pattern(this.PHONE_REGEXP)
      contact_Fax: new FormControl(''),
      customer_Description: new FormControl(''),
      address_1: new FormControl(''), // Validators.compose([Validators.required])
      address_2: new FormControl(''),
      state: new FormControl(''),     // Validators.compose([Validators.required])
      city: new FormControl(''),      // Validators.compose([Validators.required])
      zipcode: new FormControl('', Validators.compose([Validators.maxLength(10), Validators.pattern('[0-9A-Za-z ]{0,10}')])),
      net_Terms: new FormControl(''),
      prof_Cust_RefNum: new FormControl(''),
      transaction_Type: new FormControl('', Validators.compose([Validators.required])),
      LCB_ID: new FormControl(15),
      active: new FormControl(1, Validators.compose([Validators.required])),
      creditCardNo: new FormControl('', Validators.compose([Validators.pattern('^[0-9 ]{15,19}$'), ValidateCCardNumber, validateAllCCZeros])),
      ccConfirmation: new FormControl('', Validators.compose([Validators.required])),
      expireMonthYear: new FormControl('', Validators.compose([Validators.pattern('[0-9/]{7}'), ValidateIsExpiry])),
    });
  }

  initUpdateCustomerForm() {    
    this.customerForm = this.formBuilder.group({
      station: new FormControl(this.customerData[0].STATION, Validators.compose([Validators.required])),
      agency_Name: new FormControl(this.customerData[0].AGENCY_ID),
      company_Name: new FormControl(this.customerData[0].COMPANY_NAME, Validators.compose([Validators.required])),
      country: new FormControl(this.customerData[0].COUNTRY, Validators.compose([Validators.required, Validators.maxLength(2), Validators.pattern('[A-Za-z]{0,2}')])),
      contact_Name: new FormControl(this.customerData[0].CONTACT_NAME, Validators.compose([Validators.required])),
      contact_Email: new FormControl(this.customerData[0].CONTACT_EMAIL, Validators.compose([Validators.required, Validators.email])),
      contact_Phone: new FormControl(this.customerData[0].CONTACT_PHONE, Validators.compose([Validators.pattern('[0-9\-\+]*')])),  // Validators.minLength(10), Validators.maxLength(20), Validators.pattern(this.PHONE_REGEXP)
      contact_Fax: new FormControl(this.customerData[0].CONTACT_FAX),
      customer_Description: new FormControl(this.customerData[0].CUSTOMER_DESCRIPTION),
      address_1: new FormControl(this.customerData[0].ADDRESS1),
      address_2: new FormControl(this.customerData[0].ADDRESS2),
      state: new FormControl(this.customerData[0].STATE),
      city: new FormControl(this.customerData[0].CITY),
      zipcode: new FormControl(this.customerData[0].ZIPCODE, Validators.compose([Validators.maxLength(10), Validators.pattern('[0-9A-Za-z ]{0,10}')])),
      net_Terms: new FormControl(this.customerData[0].NET_TERMS),
      prof_Cust_RefNum: new FormControl(this.customerData[0].PROF_CUST_REFNUM),
      transaction_Type: new FormControl(this.customerData[0].TRANSACTION_TYPE),
      LCB_ID: new FormControl(15),
      customer_ID: new FormControl(this.customerData[0].CUSTOMER_ID),
      active: new FormControl(this.customerData[0].ACTIVE, Validators.compose([Validators.required])),
      ccConfirmation: new FormControl('', Validators.compose([Validators.required])),
      creditCardNo: new FormControl('', Validators.compose([Validators.pattern('^[0-9 ]{15,19}$'), ValidateCCardNumber, validateAllCCZeros])),
      expireMonthYear: new FormControl('', Validators.compose([Validators.pattern('[0-9/]{7}'), ValidateIsExpiry])),
    });
  }

  get customerFormcontrols() { return this.customerForm.controls; }

  onUpdateCustomer(values) {
    //console.log(values);
    this.submitted = true



    if (this.customerFormcontrols.transaction_Type.value === 'Cheque') {
      this.customerForm.get('ccConfirmation').setValue('No');
      this.customerForm.get('creditCardNo').setValidators(null);
      this.customerForm.get('creditCardNo').updateValueAndValidity();

      this.customerForm.get('expireMonthYear').setValidators(null)
      this.customerForm.get('expireMonthYear').updateValueAndValidity();
    }



    this.validateCustomer();
    this.customerForm.markAllAsTouched();
    if (this.customerForm.invalid) {
      return;
    }


    let ccNumber,expWithYear,ccExp;
    
    if(values.ccConfirmation== 'Yes'){
      ccNumber = values.creditCardNo.replace(/\s/g, '');
      ccExp = values.expireMonthYear.split("/");
      expWithYear = ccExp[1] + ccExp[0];
    }


    const isCapitalOne = this.isCapitalOneValidate() ? 'Capital One' : null;
    var data = {
      STATION: values.station,
      AGENCY_ID: values.agency_Name,
      COMPANY_NAME: values.company_Name,
      COUNTRY : values.country,
      CONTACT_NAME: values.contact_Name,
      CONTACT_EMAIL: values.contact_Email,
      CONTACT_PHONE: values.contact_Phone,
      CONTACT_FAX: values.contact_Fax,
      CUSTOMER_DESCRIPTION: values.customer_Description,
      ADDRESS1: values.address_1,
      ADDRESS2: values.address_2,
      STATE: values.state,
      CITY: values.city,
      ZIPCODE: values.zipcode,
      NET_TERMS: values.net_Terms,
      PROF_CUST_REFNUM: values.prof_Cust_RefNum == '' ? null : values.prof_Cust_RefNum,
      TRANSACTION_TYPE: values.transaction_Type,
      LCB_ID: this.authService.getCurrentUserId(),
      ACTIVE: values.active,
      CUSTOMER_ID: values.customer_ID,
      creditCardNo: ccNumber,
      ccConfirmation: values.ccConfirmation,
      expireMonthYear: expWithYear,
      promotionalContract: values.transaction_Type === 'Credit Card' ? isCapitalOne : false
    }

    this.spinner.show();
    this.arService.updateCustomerData(data).subscribe(res => {
      this.spinner.hide();
      if (res['status']) {
        this.notifier.notify('success', res['message']);
        setTimeout(() => {
          this.router.navigateByUrl("home/customers");
        }, 2000);
      } else {
        this.notifier.notify('danger', res['message'])
      }
    }, err => {
      this.notifier.notify('danger', err.message)
      console.log(err);
    })

  }

  onAgencyChange(event) {
    this.selectedStations = (event)
  }

  onTransTypeChange() {
   // console.log(this.customerFormcontrols.transaction_Type.value);
    if (this.customerFormcontrols.transaction_Type.value === 'Cheque') {
      this.customerForm.get('ccConfirmation').setValue('No');
      this.customerForm.get('creditCardNo').setValidators(null);
      this.customerForm.get('creditCardNo').updateValueAndValidity();

      this.customerForm.get('expireMonthYear').setValidators(null)
      this.customerForm.get('expireMonthYear').updateValueAndValidity();
    }

  }
  onCardConfirmationChange() {
    if (this.customerFormcontrols.ccConfirmation.value === 'Yes') {

      this.customerForm.get('creditCardNo').setValidators(Validators.compose([Validators.required,Validators.pattern('^[0-9 ]{15,19}$'), ValidateCCardNumber, validateAllCCZeros]));
      this.customerForm.get('creditCardNo').updateValueAndValidity();

      this.customerForm.get('expireMonthYear').setValidators([Validators.required,Validators.pattern('[0-9/]{7}'), ValidateIsExpiry]);
      this.customerForm.get('expireMonthYear').updateValueAndValidity();

    } else {
      this.customerForm.get('creditCardNo').setValidators(null);
      this.customerForm.get('creditCardNo').updateValueAndValidity();
      this.customerFormcontrols.creditCardNo.reset(); 

      this.customerForm.get('expireMonthYear').setValidators(null);
      this.customerForm.get('expireMonthYear').updateValueAndValidity();
      this.customerFormcontrols.expireMonthYear.reset();
    }
   // console.log(this.customerForm)
  }




  validation_messages = {
    'station': [
      { type: 'required', message: 'Station is required.' }
    ],
    // 'agency_Name': [
    //   { type: 'required', message: 'Agency Name is required.' }
    // ],
    'customer_Description': [
      { type: 'required', message: 'Customer Description is required.' }
    ],
    'net_Terms': [
      { type: 'required', message: 'Net Terms is required.' }
    ],
    'address_1': [
      { type: 'required', message: 'Address-1 is required.' }
    ],
    'address_2': [
      { type: 'required', message: 'Address-2 is required.' }
    ],
    'city': [
      { type: 'required', message: 'City is required.' }
    ],
    // 'state': [
    //   { type: 'required', message: 'State is required.' }
    // ],
    'zipcode': [
      { type: 'required', message: 'Zipcode is required.' },
      { type: 'maxlength', message: 'Zipcode should be 10 characters long.' },
      { type: 'pattern', message: 'Zipcode must not contain special characters.' },
    ],
    'company_Name': [
      { type: 'required', message: 'Company Name is required.' }
    ],
    'country': [
      { type: 'required', message: 'Country is required.' },
      { type: 'maxlength', message: 'Country should be 2 characters long.' },
      { type: 'pattern', message: 'Country must contain alphabets only.' },
    ],
    'contact_Name': [
      { type: 'required', message: 'Customer Name is required.' }
    ],
    'contact_Email': [
      { type: 'required', message: 'Email is required.' },
      { type: 'email', message: 'Email format must be similar to joe@abc.com' },
    ],
    'contact_Phone': [
      { type: 'required', message: 'Phone No is required.' },
    //  { type: 'minlength', message: 'Phone No must be minimum 10 digits long.' },
    //  { type: 'maxlength', message: 'Phone No must not be more then 20 digits long.' },
      { type: 'pattern', message: 'Phone No must not contain any alphabets or special characters  other than hyphen(-) and plus(+)' }
    ],
    'contact_Fax': [
      { type: 'required', message: 'Customer Fax is required.' }
    ],
    'prof_Cust_RefNum': [
      { type: 'required', message: 'Chase Profile ID Number is required.' }
    ],
    'transaction_Type': [
      { type: 'required', message: 'Transaction Type is required.' }
    ],
    'active': [
      { type: 'required', message: 'Status is required.' }
    ],
    'ccConfirmation': [
      { type: 'required', message: 'Card details confirmation is required.' }
    ],
    'creditCardNo': [
      { type: 'required', message: 'Credit card number is required.' },
      { type: 'invaliCCNumber', message: 'Credit card number is invalid.' },
      { type: 'validateAllCCZeros', message: 'Credit card number can not be all zeros'}
    ],
    'expireMonthYear': [
      { type: 'required', message: 'Expire Date is required.' },
      { type: 'pattern', message: 'Expire Date must be MM/YYYY format.' },
      { type: 'isExpiryInvalid', message: 'Expire Date is invalid.' }
    ],
  }

  get f(): any {
    return this.customerForm.controls;
  }

  onBack() {
    // this.location.back();
    this.router.navigateByUrl("home/customers");
  }

  validateCustomer() {
    //console.log("callingg...");

    if (this.customerFormcontrols.station.errors) {
      this.notifier.notify('warning', 'Please select Station ');
      return false;
    }
    // if (this.customerFormcontrols.agency_Name.errors) {
    //   this.notifier.notify('warning', 'Please enter Agency Name');
    //   return false;
    // }
    if (this.customerFormcontrols.company_Name.errors) {
      this.notifier.notify('warning', 'Please enter Company Name');
      return false;
    }
    if (this.customerFormcontrols.country.errors) {
      this.notifier.notify('warning', 'Please enter Country');
      return false;
    }
    if (this.customerFormcontrols.contact_Name.errors) {
      this.notifier.notify('warning', 'Please enter Customer Name');
      return false;
    }
    if (this.customerFormcontrols.contact_Email.errors) {
      this.notifier.notify('warning', 'Please enter Email');
      return false;
    }
    if (this.customerFormcontrols.contact_Phone.errors) {
      this.notifier.notify('warning', 'Please enter Phone No');
      return false;
    }
    if (this.customerFormcontrols.contact_Fax.errors) {
      this.notifier.notify('warning', 'Please enter Customer Fax');
      return false;
    }
    if (this.customerFormcontrols.customer_Description.errors) {
      this.notifier.notify('warning', 'Please enter Customer Description');
      return false;
    }
    if (this.customerFormcontrols.address_1.errors) {
      this.notifier.notify('warning', 'Please enter Address-1 ');
      return false;
    }
    if (this.customerFormcontrols.address_2.errors) {
      this.notifier.notify('warning', 'Please enter Address-2');
      return false;
    }
    // if (this.customerFormcontrols.state.errors) {
    //   this.notifier.notify('warning', 'Please enter State');
    //   return false;
    // }
    if (this.customerFormcontrols.city.errors) {
      this.notifier.notify('warning', 'Please enter City');
      return false;
    }
    if (this.customerFormcontrols.zipcode.errors) {
      this.notifier.notify('warning', 'Please enter Zipcode ');
      return false;
    }
    if (this.customerFormcontrols.net_Terms.errors) {
      this.notifier.notify('warning', 'Please enter Net Terms');
      return false;
    }
    if (this.customerFormcontrols.prof_Cust_RefNum.errors) {
      this.notifier.notify('warning', 'Please enter Chase Profile ID Number ');
      return false;
    }
    if (this.customerFormcontrols.transaction_Type.errors) {
      this.notifier.notify('warning', 'Please enter Transaction Type ');
      return false;
    }
    if (this.customerFormcontrols.active.errors) {
      this.notifier.notify('warning', 'Please select Status ');
      return false;
    }
  }
  getCapitalOneBin(cardNumber) {
    if (!cardNumber) return null;
    const cleanNumber = cardNumber.replace(/\D/g, '');
    return parseInt(cleanNumber.substring(0, 6), 10);
  }
  isCapitalOneValidate(): boolean {
    const cardNumber = this.customerForm.get('creditCardNo').value;
    if(!cardNumber && !this.capitalOneVisibleOffer) return false;
    const bin = this.getCapitalOneBin(cardNumber);
    return this.capitalOneBinNumbers.includes(bin);
  }
}

